<script lang="ts">
  import('App/CompareSimple').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('compare-simple'),
      layout: 'auto',

      props: {
        schema: {
          visibility: {
            readOnly: true,
          },
        },
        defaultFilter: {
          from_date: '2026-06-01',
          to_date: '2027-02-01',
        },
        quickFilters: [
          {
            label: 'mbdmbos',
            filter: {
              from_date: '2026-08-01',
              to_date: '2027-02-01',
            },
          },
          {
            label: 'mbdmbos-august',
            filter: {
              from_date: '2026-08-01',
              to_date: '2026-09-01',
            },
          },
          {
            label: 'mbdmbos-september',
            filter: {
              from_date: '2026-09-01',
              to_date: '2026-10-01',
            },
          },
          {
            label: 'mbdmbos-october',
            filter: {
              from_date: '2026-10-01',
              to_date: '2026-11-01',
            },
          },
          {
            label: 'mbdmbos-november',
            filter: {
              from_date: '2026-11-01',
              to_date: '2026-12-01',
            },
          },
          {
            label: 'mbdmbos-december',
            filter: {
              from_date: '2026-12-01',
              to_date: '2027-01-01',
            },
          },
          {
            label: 'week-32',
            filter: {
              from_date: '2026-08-03',
              to_date: '2026-08-10',
            },
          },
          {
            label: 'week-33',
            filter: {
              from_date: '2026-08-10',
              to_date: '2026-08-17',
            },
          },
          {
            label: 'week-34',
            filter: {
              from_date: '2026-08-17',
              to_date: '2026-08-24',
            },
          },
          {
            label: 'week-35',
            filter: {
              from_date: '2026-08-24',
              to_date: '2026-08-31',
            },
          },
          {
            label: 'week-36',
            filter: {
              from_date: '2026-08-31',
              to_date: '2026-09-07',
            },
          },
          {
            label: 'week-37',
            filter: {
              from_date: '2026-09-07',
              to_date: '2026-09-14',
            },
          },
          {
            label: 'week-38',
            filter: {
              from_date: '2026-09-14',
              to_date: '2026-09-21',
            },
          },
          {
            label: 'week-39',
            filter: {
              from_date: '2026-09-21',
              to_date: '2026-09-28',
            },
          },
          {
            label: 'week-40',
            filter: {
              from_date: '2026-09-28',
              to_date: '2026-10-05',
            },
          },
          {
            label: 'week-41',
            filter: {
              from_date: '2026-10-05',
              to_date: '2026-10-12',
            },
          },
          {
            label: 'week-42',
            filter: {
              from_date: '2026-10-12',
              to_date: '2026-10-19',
            },
          },
          {
            label: 'week-43',
            filter: {
              from_date: '2026-10-19',
              to_date: '2026-10-26',
            },
          },
          {
            label: 'week-44',
            filter: {
              from_date: '2026-10-26',
              to_date: '2026-11-02',
            },
          },
          {
            label: 'week-45',
            filter: {
              from_date: '2026-11-02',
              to_date: '2026-11-09',
            },
          },
          {
            label: 'week-46',
            filter: {
              from_date: '2026-11-09',
              to_date: '2026-11-16',
            },
          },
          {
            label: 'week-47',
            filter: {
              from_date: '2026-11-16',
              to_date: '2026-11-23',
            },
          },
          {
            label: 'week-48',
            filter: {
              from_date: '2026-11-23',
              to_date: '2026-11-30',
            },
          },
          {
            label: 'week-49',
            filter: {
              from_date: '2026-11-30',
              to_date: '2026-12-07',
            },
          },
          {
            label: 'week-50',
            filter: {
              from_date: '2026-12-07',
              to_date: '2026-12-14',
            },
          },
          {
            label: 'week-51',
            filter: {
              from_date: '2026-12-14',
              to_date: '2026-12-21',
            },
          },
          {
            label: 'week-52',
            filter: {
              from_date: '2026-12-21',
              to_date: '2026-12-28',
            },
          },
          {
            label: 'week-53',
            filter: {
              from_date: '2026-12-28',
              to_date: '2027-01-04',
            },
          },
        ],
      },
    });
  });
</script>

<div id="compare-simple" />
